<template>
    <li :class="['contact-list', isSelected ? 'selected' : '']" v-on:click="openChat">
        <img class="contact-img" :src="pictureUrl">
        <div class="contact-box"> 
            <div class="contact-content">
                <div class="message-timestamp">{{timeStamp}}</div>
                <div class="contact-name">{{fullName}}</div>
                <div class="last-message">{{lastMessage}}</div>
            </div>
        </div>
    </li>
</template>

<script>

import {EventBus} from '../../router/index';
import TimeUtils from '../../javascript-classes/utils/time';

const ANONYMOUS_IMG = "/static/img/anonymous.svg";
const MAX_VISIBLE_MESSAGE_LENGTH = 25;
const MAX_VISIBLE_NAME_LENGTH = 25;

export default {
    props: {
        contact: {},
        user: {},
        isSelected: Boolean
    },

    computed: {
        fullName() {
            var fullName = this.contact.toInfo.firstName + ' ' + this.contact.toInfo.lastName;

            if (fullName.length > MAX_VISIBLE_NAME_LENGTH) {
                fullName = fullName.substring(0, MAX_VISIBLE_NAME_LENGTH) + ' . . .';
            }

            return fullName;
        },

        lastMessage() {
            var message = this.contact.lastMessage;

            if (!message) {
                return '';
            }

            if (message.length > MAX_VISIBLE_MESSAGE_LENGTH) {
                message = message.substring(0, MAX_VISIBLE_MESSAGE_LENGTH) + ' . . .';
            }

            return message;
        },

        pictureUrl() {
            return this.contact && this.contact.toInfo && this.contact.toInfo.pictureUrl && this.contact.toInfo.pictureUrl !== '' ? this.contact.toInfo.pictureUrl : ANONYMOUS_IMG;
        },

        timeStamp() {
            return TimeUtils.formatFromNow(this.contact.timestamp, (key) => { return this.$t('str.' + key); });
        }
    },

    methods: {
        openChat() {
            EventBus.$emit('openChat', this.contact.toInfo);

            if (window.screen.width < 600) { // Only close if screen is small to show both
                EventBus.$emit('closeHistory');
            }
        }
    }
};

</script>

<style lang="scss">

.contact-list {
    text-decoration: none;
    cursor: pointer;
    list-style-type: none;
    border: 1px solid #969696; 
    border-radius: 35px 0 0 35px ; 
    user-select: none;
    background-color: #333;

    .contact-img {
        width: 50px;
        border-radius: 50%;
        margin-top: 10px;
        margin-left: 10px;
        display: inline-block;
        margin-bottom: 10px;
    }

    .contact-box {
        font-family: "Poppins", sans-serif;  
        display: inline-block; 
        min-width: 80%;            
        float: right;   
        line-height: 25px; 
        margin-top: 10px;         

        .contact-name {
            font-size: 13px;
            font-weight: 600;
            color: #d4451d;
            padding-left: 5px;
        }

        .message-timestamp {
            font-size: 10px;
            float: right;
            margin-right: 10px;
            color: #969696;
        }

        .last-message {
            font-size: 13px;
            padding-left: 10px;
            color: #969696;
        }
    }
}

.contact-list.selected {
    background-color: #d4451d;

    .contact-box {
        .contact-name,
        .message-timestamp,
        .last-message {
            color: black;
        }
    }
}

</style>



// WEBPACK FOOTER //
// ChatListItem.vue?f6152126